export default __webpack_public_path__ + "static/media/XS4 One.c772486e.jpg";